<template>
    <div :class="this.alertClass" v-if="this.$store.state.messageText != ''">
         {{$store.state.messageText}}
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data: function () {
        return {

        }
    },
    computed: {
    // a computed getter
        alertClass: function () {
          // `this` points to the vm instance
          return 'alert-component alert alert-' + this.$store.state.messageType;
        }
    }
}
</script>
